/** Platform staff who may see internal tools such as Meta API test. */
export function isPlatformAdmin(account) {
  const type = String(account?.type || "").toLowerCase();
  return type === "admin" || type === "super_admin";
}
